<template>
  <div :id="id" :class="className" ref="echarts" :style="{ height: height, width: width }" />
</template>

<script>
const echarts = require("echarts");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "pie-chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    xData:{
        type:Array,
    },
    yData:{
        type:Array,
    },
    height: {
      type: String,
      default: "100%",
    },
    series:{
        type:Array,
    },
    option: {
      type: Object,
    },
    unit:{
      type: String,
      default: "kVA",
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
      let self = this
      self.initChart();
			 window.addEventListener('resize',()=>{
         if(self.myChart){
           self.myChart.resize();
         }
				
			});
  },
  beforeDestroy() {
    if (!this.myChart) {
      return;
    }
    this.myChart.dispose();
    this.myChart = null;
  },
  methods: {
    initChart(){
      let myChart = echarts.init(this.$refs.echarts);
			this.myChart = myChart
      this.myChart.clear()
      let color = ["#ffcd8b", "#0D94FF", "#F6BD16", "#E8684A"]
      let seriesList = []
      let legendList = []
      this.series.forEach((e,i)=>{
          legendList.push({
            name:e.name,
            itemStyle: {
              color: color[i],
            },
          })
          let itemStyle = {}
          if(e.type=='line'){
            itemStyle = {
              // normal: {
              //     lineStyle: {        // 系列级个性化折线样式  
              //         width: 2,  
              //         type: 'solid',  
              //         color: color[i] //折线的颜色
              //     }  ,
              //     color: 'rgba(90,216,206, 0)',  //拐点颜色
              // },
              emphasis:{
                  color:color[i],
                  borderWidth:2,
                  borderColor:'#fff',
                  shadowColor:'#00FFFF',
                  shadowBlur:10
              },
            }
          }
          seriesList.push({
            name:e.name,
            data:e.data,
            type:e.type,
            symbol: 'circle',
            smooth:true,
            showSymbol: false,
            itemStyle:itemStyle,
            areaStyle :{
                color: i==0?'rgba(246,189,22,0.3)': 'rgba(18,144,255,0.3)'   //折线区域的背景颜色
            }
          })
      })
      let option = {
          color:color,
          // title: {
          //     text:this.unit || 'kVA',
          //     x: '1%',
          //     y: '-3%',
          //     textStyle:{                  //标题样式
          //         fontSize: '12',
          //         fontFamily:'Source Han Sans CN',
          //         color:'rgba(230,243,253, 0.7)',
          //     }
          // },
          legend: {
              itemWidth: 12,
              itemHeight: 12,
              x: "center",
              // data: ["本月", "上月"],
              icon: "rect",
              left: "center", // 图例的位置
              textStyle: {
                color: "#ffffff",
              },
              data:legendList,
               data: [
                          {
                    name: '今日',
                    itemStyle: {
                      color: color[0],
                    },
                },
                {
                    name: '昨日',
                    itemStyle: {
                      color: color[1],
                    },
                }
              ]
          },
          xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xData,
              axisLine:{
                  lineStyle:{
                      color:'#0D94FF'
                  }
              },
                axisLabel: {
                  color: "#f0f0f0"  //坐标轴的文本颜色
              },
              axisTick:{       
                  "show":false   //去掉x轴刻度线
              },
          },
          tooltip: {
            trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
            backgroundColor: 'rgba(0, 10, 26, 0.8)',
            borderRadius: 8,  
            borderWidth: 0,
            shadowColor:'rgba(13, 148, 255, 0.8)',
            axisPointer: {// 坐标轴指示器，坐标轴触发有效
              type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            },
              textStyle: {
                  color: '#fff'
              },
          },
          title: {
            text: this.unit || 'kVA',
            x: '3%',
            y: '-2%',
            textStyle:{                  //标题样式
                fontSize: '12',
                fontFamily:'Source Han Sans CN',
                color:'rgba(230,243,253, 0.7)',
            }
          },
          yAxis: {
              type: 'value',
              // name:this.unit || 'kVA',
              axisLine:{
                  show:false,
                  lineStyle:{
                      color:'rgba(230,243,253, 0.7)'
                  }
              },
              axisLabel: {
                  color: "#f0f0f0"  //坐标轴的文本颜色
              },
              splitLine: {           //分割线
                  show: false,     //控制分割线是否显示
                  // lineStyle:{       //分割线的样式
                  //     color: ['rgba(43,70,126,1)'],
                  //     width: 2,
                  //     type: 'solid'
                  // }
                  },
          },
          series: seriesList,
          grid: {
              left: "3%",
              right: "5%",
              bottom: "1%",
              top: "15%",
              containLabel: true,
          },
      }
			this.myChart.setOption(option,true);
      
    }
  },
  watch: {
    series: function(newData, oldData) {
      this.myChart.clear();
      this.myChart.dispose();
      this.myChart = null;
      this.initChart();
    }
  },
};
</script>
